export default __webpack_public_path__ + "static/shruteeGanguly4-ccb348f5731e179f03358679063f075f.jpg";